export default {
  // Page title
  title: "Estadísticas de Notificaciones",

  // Search form
  searchForm: {
    pushTime: "Hora de Notificación",
    pushTimePlaceholder: "Seleccione rango de fechas",
    memberAccount: "Miembro a Notificar",
    memberAccountPlaceholder: "Ingrese",
    pushType: "Tipo de Notificación",
    pushTypePlaceholder: "Seleccione",
    search: "Consultar",
    reset: "Restablecer"
  },

  // Table column titles
  table: {
    memberAccount: "Miembro a Notificar",
    pushType: "Tipo de Notificación",
    subPushType: "Subtipo",
    pushTitle: "Título de Notificación",
    pushContent: "Contenido de Notificación",
    pushTime: "Hora de Notificación",
    status: "Estado",
    createTime: "Hora de Creación"
  },

  // Fields
  pushName: "Nombre del Mensaje",
  pushType: "Tipo de Notificación",
  subPushType: "Subtipo",
  pushTime: "Hora de Notificación",
  memberType: "Tipo de Miembro",
  memberTypePlaceholder: "Seleccione",
  createTime: "Hora de Operación",
  createUserName: "Operador",
  sendUserCount: "Cantidad de Usuarios Enviados",
  pushSuccessToFailed: "Total de Notificaciones/Recibidas",
  pushOpenCount: "Cantidad de Aperturas",
  pushOpenRate: "Tasa de Apertura",
  pleaseEnter: "Ingrese"
};
